export class Paginacion {
    public constructor( Json: any = null ) {

        if ( Json ) {
            this.Total = Json.total;
            this.Resultados = Json.results;
            this.Completa = Json.paging.complete;
            this.Final = Json.paging.end;
            this.Pagina = Json.paging.page;
            this.Paginas = Json.paging.pages;
        }
    }

    public Total: number = 0;
    public Resultados: number = 0;
    public Completa: boolean = false;
    public Final: boolean = false;

    public Pagina: number = 0;
    public Paginas: number = 0;

    public PermiteAvanzar() {
        return this.Total > 0 && !this.Final && !this.Completa;
    }

    public PermiteRetroceder() {
        return this.Total > 0 && this.Pagina > 1 && !this.Completa;
    }

    public Siguiente() {
        return this.PermiteAvanzar() ? this.Pagina + 1 : this.Pagina;
    }

    public Anterior() {
        return this.PermiteRetroceder() ? this.Pagina - 1 : this.Pagina;
    }

    public Ultima() {
        return this.Paginas;
    }

    public Primera() {
        return 1;
    }
}
